"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6016],{

/***/ 96679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    background-color: rgba(0, 0, 0, 0.11);\n    border-radius: 4px;\n    animation: pulse 1.5s ease-in-out 0.5s infinite;\n\n    @keyframes pulse {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width, _height = param.height, height = _height === void 0 ? 16 : _height, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        width: width,
        height: height,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Skeleton__StyledWrapper",
    componentId: "sc-62e13890-0"
})(_templateObject1(), function(param) {
    var width = param.width, height = param.height;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), typeof width === "number" ? "".concat(width, "px") : width, typeof height === "number" ? "".concat(height, "px") : height);
});


/***/ }),

/***/ 9289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53893);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67235);
/* harmony import */ var components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36957);
/* harmony import */ var components_LoginAlert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39749);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38405);
/* harmony import */ var hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2165);
/* harmony import */ var utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65342);
/* harmony import */ var _constant_logoImageSize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96536);
/* harmony import */ var _context_AnalysisReportsContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47665);
/* harmony import */ var _hooks_useIncreaseCount__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71568);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    height: 92px;\n    border-bottom: 1px solid ",
        ";\n\n    &:first-child {\n      border-top: 1px solid ",
        ";\n    }\n    .item-info {\n      flex: 1;\n      cursor: pointer;\n      overflow: hidden;\n      .company-name {\n        font-size: 16px;\n        margin-bottom: 4px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        word-wrap: break-word;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n      }\n\n      .item-count {\n        font-size: 12px;\n        font-weight: normal;\n        display: flex;\n        align-items: center;\n        dt:nth-of-type(2)::before {\n          content: '';\n          display: inline-block;\n          width: 1px;\n          height: 8px;\n          margin: 0 8px;\n          background: ",
        ";\n        }\n        dd {\n          margin-left: 4px;\n        }\n      }\n    }\n\n    > button {\n      width: 28px;\n      cursor: pointer;\n      background: none;\n      padding: 0px;\n      border: none;\n    }\n    .scrap-btn {\n      width: 40px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      flex-shrink: 0;\n      gap: 5px;\n      padding-top: 10px;\n      cursor: pointer;\n\n      > p {\n        font-size: 12px;\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var AnalysisMainResultItem = function(param) {
    var item = param.item, _isScrapScreen = param.isScrapScreen, isScrapScreen = _isScrapScreen === void 0 ? false : _isScrapScreen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var fluterInappwebview = (0,hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().fluterInappwebview;
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_9__/* .useCurrentUserContext */ .O)().user;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_AnalysisReportsContext__WEBPACK_IMPORTED_MODULE_11__/* .AnalysisReportsContext */ .kD).state;
    var updateAnalysisReportScrap = (0,_hooks_useIncreaseCount__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().updateAnalysisReportScrap;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useGqlDeleteAnalysisReportScrapMutation */ .nXl)(), 1), deleAnalysisReportScrap = ref1[0];
    var closeLoginAlert = function() {
        setShowLoginAlert(false);
    };
    var handleClickBookmark = function() {
        if (!user) {
            setShowLoginAlert(true);
            return;
        }
        updateAnalysisReportScrap({
            variables: {
                input: {
                    analysisReportId: item.id
                }
            },
            optimisticResponse: {
                __typename: "Mutation",
                updateAnalysisReportScrap: {
                    scrapped: !item.viewerScrapped,
                    __typename: "UpdateAnalysisReportScrapPayload"
                }
            },
            update: function(cache) {
                var cachedData = cache.readQuery({
                    query: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .GqlAnalysisReportsDocument */ .$A3,
                    variables: state
                });
                cache.writeQuery({
                    query: generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .GqlAnalysisReportsDocument */ .$A3,
                    variables: state,
                    data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, cachedData), {
                        analysisReports: {
                            __typename: "AnalysisReportConnection",
                            totalCount: cachedData === null || cachedData === void 0 ? void 0 : cachedData.analysisReports.totalCount,
                            nodes: cachedData === null || cachedData === void 0 ? void 0 : cachedData.analysisReports.nodes.map(function(node) {
                                if (node.id === item.id) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, node), {
                                        viewerScrapped: !item.viewerScrapped,
                                        scrapCount: item.viewerScrapped ? node.scrapCount - 1 : node.scrapCount + 1
                                    });
                                }
                                return node;
                            })
                        }
                    })
                });
            }
        });
    };
    var handleClickDelete = function() {
        deleAnalysisReportScrap({
            variables: {
                analysisReportId: item.id
            },
            refetchQueries: [
                generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .GqlViewerScrappedAnalysisReportsDocument */ .axq,
                generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .GqlUserScrapCountsDocument */ .nK8, 
            ],
            onCompleted: function() {
                if (isWebview) {
                    fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveScrap");
                }
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                alt: item.title,
                width: _constant_logoImageSize__WEBPACK_IMPORTED_MODULE_10__/* .ANALYSIS_RESULT_ITEM_LOGO_SIZE */ .ju,
                height: _constant_logoImageSize__WEBPACK_IMPORTED_MODULE_10__/* .ANALYSIS_RESULT_ITEM_LOGO_SIZE */ .ju,
                objectFit: "contain",
                loader: utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_17__/* .imageLoader */ .X,
                src: (0,utils_optimizeImageUrl__WEBPACK_IMPORTED_MODULE_17__/* .optimizeImageUrl */ .m)({
                    url: item.thumbnailImage.url,
                    width: "auto",
                    height: _constant_logoImageSize__WEBPACK_IMPORTED_MODULE_10__/* .ANALYSIS_RESULT_ITEM_LOGO_SIZE */ .ju
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                className: "item-info",
                href: "/company-analysis/".concat(item.id),
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: "company-name",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("dl", {
                            className: "item-count",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dt", {
                                    children: "조회수"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dd", {
                                    children: (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_7__/* .getLimitNumText */ .i)({
                                        number: item.impressionCount,
                                        limit: 9999
                                    })
                                }),
                                isScrapScreen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dt", {
                                            children: "스크랩 수"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("dd", {
                                            children: (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_7__/* .getLimitNumText */ .i)({
                                                number: item.scrapCount,
                                                limit: 9999
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            isScrapScreen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                type: "button",
                className: "close-btn",
                onClick: handleClickDelete,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8, {
                    width: 15,
                    height: 15
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                type: "button",
                className: "scrap-btn",
                onClick: handleClickBookmark,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_4__/* .BookMark */ .QC, {
                        isOn: item.viewerScrapped,
                        className: "bookmark-icon",
                        strokeType: "#666666",
                        color: "#01a0ff"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "scrap-count",
                        children: item.scrapCount
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_LoginAlert__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnalysisMainResultItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "AnalysisResultItem__StyledWrapper",
    componentId: "sc-ebaedb18-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(_templateObject(), theme.background.bg_1, theme.background.bg_1, theme.line.line_1, theme.color.text_2);
});


/***/ }),

/***/ 6226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);
/* harmony import */ var _app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96679);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    height: 92px;\n    border-bottom: 1px solid ",
        ";\n\n    &:first-child {\n      border-top: 1px solid ",
        ";\n    }\n    .item-info {\n      .company-name {\n        margin-bottom: 10px;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var AnalysisResultItemSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: 60,
                height: 60
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "item-info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "company-name",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            width: 100,
                            height: 15
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        width: 40,
                        height: 10
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnalysisResultItemSkeleton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "AnalysisResultItemSkeleton__StyledWrapper",
    componentId: "sc-5c05958d-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.background.bg_1, theme.background.bg_1);
});


/***/ }),

/***/ 96536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xq": function() { return /* binding */ ANALYSIS_POPULAR_ITEM_LOGO_SIZE; },
/* harmony export */   "hF": function() { return /* binding */ CV_ANALYSIS_RESULT_ITEM_LOGO_SIZE; },
/* harmony export */   "ju": function() { return /* binding */ ANALYSIS_RESULT_ITEM_LOGO_SIZE; }
/* harmony export */ });
var ANALYSIS_RESULT_ITEM_LOGO_SIZE = 84;
var CV_ANALYSIS_RESULT_ITEM_LOGO_SIZE = 60;
var ANALYSIS_POPULAR_ITEM_LOGO_SIZE = {
    PC: 92,
    MO: 60
};


/***/ }),

/***/ 47665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xm": function() { return /* binding */ AnalysisReportsContextProvider; },
/* harmony export */   "aY": function() { return /* binding */ getInitialState; },
/* harmony export */   "kD": function() { return /* binding */ AnalysisReportsContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);
/* harmony import */ var _analysisReportsReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63924);




var getInitialState = function() {
    return {
        filterBy: {
            type: generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .AnalysisReportType.COMPANY */ .Xfp.COMPANY
        },
        orderBy: {
            field: generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .AnalysisReportOrderField.CREATED_AT */ ._kI.CREATED_AT,
            direction: generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .OrderDirection.DESC */ .N9t.DESC
        },
        pagination: {
            page: 1,
            pageSize: 20
        }
    };
};
var AnalysisReportsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    state: getInitialState(),
    dispatch: function() {
        return null;
    }
});
var AnalysisReportsContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_analysisReportsReducer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, getInitialState()), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnalysisReportsContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};



/***/ }),

/***/ 63924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ dispatchFilterByAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _AnalysisReportsContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47665);



var analysisReportsReducer = function(state, action) {
    var initialData = (0,_AnalysisReportsContext__WEBPACK_IMPORTED_MODULE_0__/* .getInitialState */ .aY)();
    switch(action.type){
        case "SET_FILTER_BY":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                filterBy: action.filterBy
            });
        case "SET_ORDER_BY":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                orderBy: action.orderBy
            });
        case "SET_PAGINATION":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                pagination: action.pagination
            });
        case "RESET":
            return initialData;
        case "RE_INIT":
            return {
                filterBy: action.filterBy,
                orderBy: action.orderBy,
                pagination: action.pagination
            };
        default:
            return state;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (analysisReportsReducer);
var dispatchFilterByAction = function(dispatch, filter) {
    dispatch({
        type: "SET_FILTER_BY",
        filterBy: filter
    });
};


/***/ }),

/***/ 71568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);


var useIncreaseCount = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlUpdateAnalysisReportScrapMutation */ .Y$l)(), 1), updateAnalysisReportScrap = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useGqlIncrementAnalysisReportShareMutation */ .oH8)(), 1), incrementAnalysisReportShareMutation = ref1[0];
    var incrementAnalysisReportShare = function(reportId) {
        incrementAnalysisReportShareMutation({
            variables: {
                analysisReportId: reportId
            }
        });
    };
    return {
        updateAnalysisReportScrap: updateAnalysisReportScrap,
        incrementAnalysisReportShare: incrementAnalysisReportShare
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIncreaseCount);


/***/ }),

/***/ 39749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17563);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75551);
/* harmony import */ var components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13133);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  & > b,\n  strong {\n    font-size: 18px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LoginAlert = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var goLogin = function() {
        var next = props.chatRoomId ? "".concat(window.location.href, "?").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE_QUERY_KEY */ .v, "=").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE.DEFAULT */ .X.DEFAULT, "&chatRoomId=").concat(props.chatRoomId) : window.location.href;
        router.push("/login?".concat(query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
            next: next
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                    children: "로그인 후 이용가능한 서비스입니다."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                    children: "로그인 하시겠습니까?"
                })
            ]
        }),
        onConfirm: goLogin,
        confirmLabel: "확인"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginAlert);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "LoginAlert__StyledWrapper",
    componentId: "sc-de340b2b-0"
})(_templateObject());


/***/ }),

/***/ 25536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ ACTIVITY_TYPE_TEXT; },
/* harmony export */   "ID": function() { return /* binding */ ORDER_TEXT; },
/* harmony export */   "RO": function() { return /* binding */ ACTIVITY_TYPE_TEXT_ID; },
/* harmony export */   "T5": function() { return /* binding */ JOBTYPE_JSONLD; },
/* harmony export */   "VG": function() { return /* binding */ ACTIVITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "do": function() { return /* binding */ ACTIVITY_TYPE_ID_NAME; },
/* harmony export */   "fO": function() { return /* binding */ COMPANY_ANALYSIS_ORDER_TEXT; },
/* harmony export */   "g1": function() { return /* binding */ COMMUNITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "h0": function() { return /* binding */ COVER_LETTER_SEARCH_ORDER_TEXT; },
/* harmony export */   "i6": function() { return /* binding */ ORGANIZATIONS; },
/* harmony export */   "ic": function() { return /* binding */ USER_DELETE_REASON_TYPE_TEXT; },
/* harmony export */   "n2": function() { return /* binding */ ACTIVITY_LIST_ORDER_TEXT; }
/* harmony export */ });
/* unused harmony export JOBTYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var _obj;
var ORDER_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "생성일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECENT */ .Ehb.RECENT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "지원자순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.DEAD_LINE */ .Ehb.DEAD_LINE, "마감일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.STATUS_UPDATED_AT */ .Ehb.STATUS_UPDATED_AT, "수정일순"), _obj);
var _obj1;
var ACTIVITY_LIST_ORDER_TEXT = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "최근 조회 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "최근 댓글 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), _obj1);
var _obj2;
var ACTIVITY_POST_SEARCH_ORDER_TEXT = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.CREATED_AT */ .H1T.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.VIEW_COUNT */ .H1T.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.SCRAP_COUNT */ .H1T.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RECRUIT_CLOSEAT */ .H1T.RECRUIT_CLOSEAT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RELEVANCE */ .H1T.RELEVANCE, "관련도순"), _obj2);
var _obj3;
var COMMUNITY_POST_SEARCH_ORDER_TEXT = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.CREATED_AT */ .GK1.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.VIEW_COUNT */ .GK1.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.RELEVANCE */ .GK1.RELEVANCE, "관련도순"), _obj3);
var _obj4;
var COVER_LETTER_SEARCH_ORDER_TEXT = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RELEVANCE */ .lNF.RELEVANCE, "관련도순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.SCRAP_COUNT */ .lNF.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.PASSED_AT */ .lNF.PASSED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RECENT_SCRAP_COUNT */ .lNF.RECENT_SCRAP_COUNT, "최근 인기순"), _obj4);
var _obj5;
var COMPANY_ANALYSIS_ORDER_TEXT = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.CREATED_AT */ ._kI.CREATED_AT, "최근 등록순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.IMPRESSION_COUNT */ ._kI.IMPRESSION_COUNT, "조회순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.SCRAP_COUNT */ ._kI.SCRAP_COUNT, "스크랩순"), _obj5);
var _obj6;
var ORGANIZATIONS = (_obj6 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MAJOR_COMPANY */ .BRt.MAJOR_COMPANY, "대기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.SMALL_BUSINESS */ .BRt.SMALL_BUSINESS, "중소기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.PUBLIC_INSTITUTIONS */ .BRt.PUBLIC_INSTITUTIONS, "공공기관/공기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.FOREIGN_COMPANIES */ .BRt.FOREIGN_COMPANIES, "외국계기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MIDSIZE_BUSINESS */ .BRt.MIDSIZE_BUSINESS, "중견기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.NON_PROFIT_ORGANIZATION */ .BRt.NON_PROFIT_ORGANIZATION, "비영리단체/협회/재단"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.START_UP */ .BRt.START_UP, "스타트업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.BANK */ .BRt.BANK, "금융권"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.HOSPITAL */ .BRt.HOSPITAL, "병원"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.CLUB */ .BRt.CLUB, "동아리/학생자치단체"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.ETC */ .BRt.ETC, "기타"), _obj6);
var _obj7;
var JOBTYPE = (_obj7 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력직"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj7);
var _obj8;
/**
 * 네이버 서치어드바이저 `experienceRequirements` 가이드에 맞추어 인턴, 신입을 모두 **신입**으로 통일하고 경력직을 **경력**으로 통일합니다.
 *
 * https://searchadvisor.naver.com/guide/structured-data-job
 *
 * TODO : 추후 JOBTYPE을 다른곳에서 사용하지 않는다면 해당 상수를 삭제하고 JOBTYPE_JSONLD를 사용하는 곳에서 JOBTYPE을 사용하도록 변경합니다.
 */ var JOBTYPE_JSONLD = (_obj8 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj8);
var _obj9;
var ACTIVITY_TYPE_TEXT = (_obj9 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, "대외활동"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, "동아리"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, "공모전"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, "채용"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, "교육"), _obj9);
var _obj10;
var ACTIVITY_TYPE_ID_NAME = (_obj10 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION), _obj10);
var _obj11;
var ACTIVITY_TYPE_TEXT_ID = (_obj11 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION), _obj11);
var _obj12;
var USER_DELETE_REASON_TYPE_TEXT = (_obj12 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LOW_FREQUENCY_USES */ .BFP.LOW_FREQUENCY_USES, "사용빈도 낮음"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_UX_UI */ .BFP.POOR_UX_UI, "사이트 이용 불편"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LACK_OF_CONTENT_QUALITY */ .BFP.LACK_OF_CONTENT_QUALITY, "콘텐츠 내용 부족"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.OUT_OF_JOB_MARKET */ .BFP.OUT_OF_JOB_MARKET, "대외활동/인턴/구직활동 종료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_SECURITY */ .BFP.POOR_SECURITY, "개인정보 유출 우려"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.ETC */ .BFP.ETC, "기타"), _obj12);


/***/ }),

/***/ 65342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; },
/* harmony export */   "m": function() { return /* binding */ optimizeImageUrl; }
/* harmony export */ });
var optimizeImageUrl = function(options) {
    if (!options.url) return "";
    return "".concat(options.url, "?d=").concat(options.width, "x").concat(options.height);
};
var imageLoader = function(param) {
    var src = param.src;
    return "".concat(src);
};


/***/ })

}]);